import { render, staticRenderFns } from "./ProducerReportsCategory.vue?vue&type=template&id=0afe33ea&"
import script from "./ProducerReportsCategory.vue?vue&type=script&lang=js&"
export * from "./ProducerReportsCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports